import { Moment } from 'moment';

import {
  AutoritePrescriptriceDtoQualiteAutoriteEnum,
  EtatDtoEtatEnum,
  FicheJudiciaireRequestDtoValeurJuridiqueEnum,
  JuridictionResponseDto,
  MarqueDto,
  ModeleDto,
  UniteFOResponseDto,
} from 'lib_api/lib/api/gen';

import { BaseOptionType } from 'components/BaseForm/Select/BaseSelect';

export interface FicheInfractionFormValues {
  natureForFront?: string;
  idCorrelationAutoriteFourriere?: string;
  dateConstatation?: Moment;
  nomAutoritePrescriptrice?: string;
  qualiteAutorite?: AutoritePrescriptriceDtoQualiteAutoriteEnum;
  nomAgent?: string;
  nigend?: string;
  uniteFo?: BaseOptionType<UniteFOResponseDto>;
  emailUniteFo?: string;
  lieuPrive?: boolean;
  idMotifMef?: string;
  adresseEnlevement?: string;
  communeEnlevement?: string;
  nuit?: boolean;
  pluieOuNeige?: boolean;
  autoriteLeverMesure?: string;
  dateRedaction?: Moment;
}

export interface FicheVehiculeFormValues {
  sansPlaque?: boolean;
  plusieursPlaques?: boolean;
  plusieursNumeroDeSerie?: boolean;
  paysEtranger?: boolean;
  genre?: string;
  numero?: string;
  numeroImmatriculationVisible?: string;
  vin?: string;
  marque?: BaseOptionType<MarqueDto>;
  modele?: BaseOptionType<ModeleDto>;
  couleur?: string;
  etat?: EtatDtoEtatEnum;
  precisionEtat?: string;
  verrouillage?: VehiculeVerouillage[];
  accessoires?: VehiculeAccessoire[];
  telephonePortable?: boolean;
  nombreAntennes?: number;
  objetsVisibles?: string;
  observations?: string;
}

export interface FicheJudiciaireFormValues {
  juridiction?: BaseOptionType<JuridictionResponseDto>;
  numeroParquet?: string;
  numeroPv?: string;
  numeroIDJ?: string;
  valeurJuridique?: FicheJudiciaireRequestDtoValeurJuridiqueEnum;
}

export interface FicheFourriereFormValues {
  dateEnlevement?: Moment;
  dateEntree?: Moment;
}

export interface FicheDescriptiveFormValues {
  ficheInfraction: FicheInfractionFormValues;
  ficheVehicule: FicheVehiculeFormValues;
  ficheFourriere: FicheFourriereFormValues;
  FicheJudiciaire: FicheJudiciaireFormValues;
}

export enum VehiculeVerouillage {
  VEROUILLAGE_PORTES = 'portes',
  VEROUILLAGE_COFFRES = 'coffres',
}

export enum VehiculeAccessoire {
  ACCESSOIRE_AUTO_RADIO = 'autoRadio',
  ACCESSOIRE_POSTE_CB = 'posteCB',
}
